module.exports = __webpack_public_path__ + "static/media/Notifications.456cad7c.svg";